import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStateLoadCoefficients, ILoadCoefficientsPayload } from "../types";
import { GetLoadCoefficients } from "./thunk";
import { IAcademicYearPayload } from "@pages/EducationalSettings/AcademicYear/types";

const initialState: IInitialStateLoadCoefficients = {
    loadCoefficients: [],
    isLoadingCoefficients: false,
    filteredLoadCoefficients: [],
    selectedLoadCoefficientsIDs: [],
};

const loadCoefficientsSlice = createSlice({
    name: "loadCoefficients",
    initialState,
    reducers: {
        setLoadCoefficients: (
            state,
            action: PayloadAction<{ data: ILoadCoefficientsPayload[]; defaultLanguage: string }>
        ) => {
            const { data, defaultLanguage } = action.payload;
            state.loadCoefficients = data;
            state.filteredLoadCoefficients = state.loadCoefficients.flatMap(data =>
                data.translations
                    .filter(elem => elem.slug === defaultLanguage && elem.name)
                    .map(elem => ({
                        id: data.id,
                        name: elem.name as string,
                    }))
            );
        },
        setSelectedLoadCoefficientsIDs: (state, action) => {
            state.selectedLoadCoefficientsIDs = action.payload;
        },
        updateCoefficients: (state, action: PayloadAction<IAcademicYearPayload>) => {
            const updateData = action.payload;

            state.loadCoefficients = state.loadCoefficients.map(elem => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetLoadCoefficients.pending, state => {
                state.isLoadingCoefficients = true;
            })
            .addCase(GetLoadCoefficients.fulfilled, state => {
                state.isLoadingCoefficients = false;
            })
            .addCase(GetLoadCoefficients.rejected, state => {
                state.isLoadingCoefficients = false;
            });
        // .addCase(GetDeleteNormTypes.pending, (state) => {
        //     state.isLoadingNormTypes = true;
        // })
        // .addCase(GetDeleteNormTypes.fulfilled, (state) => {
        //     state.isLoadingNormTypes = false;
        // })
        // .addCase(GetDeleteNormTypes.rejected, (state) => {
        //     state.isLoadingNormTypes = false;
        // });
    },
});

export const { setLoadCoefficients, setSelectedLoadCoefficientsIDs, updateCoefficients } =
    loadCoefficientsSlice.actions;

export default loadCoefficientsSlice;
